/* eslint-disable react-hooks/exhaustive-deps */
import LoadingContent from 'components/LoadingContent';
import { useFormik } from 'formik';
import React, { useEffect } from 'react';
import TopProcessBar from 'screen/selectCollege/TopProcessBar';
import { Container, Form, Spinner, Button } from 'react-bootstrap';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { useHistory, useLocation } from 'react-router-dom';
import { routers } from 'router/router';
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import CalculateOutlinedIcon from '@mui/icons-material/CalculateOutlined';
import SearchIcon from '@mui/icons-material/Search';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';
import Grid from '@mui/joy/Grid';
import { ExpandMore } from 'screen/activitiesAndHonors/Activities';
import APSubjectConfig from './components/APSubjectConfig';
import TextInput from 'components/input/textInput';
import {
  BoolToString,
  checkEnableParseJSON,
  dateFormat,
  formatBoolean,
  reorder,
} from 'components/helper/helper';
import { fixApSubjectTestValues } from 'screen/common/helper/fixValuesOnLoad';
import { getACTSubjectTest, updateACTSubjectTest } from 'app/testingSlice/testingSlice';
import pageStatusService from 'services/pageStatusService';
import { PAGE_NAME } from 'constants/common';
import { toggleReviewedAndComplete } from 'services/reviewAndComplete';
import { ModalCheckTestFields } from '../common/ModalCheckTestFields';
import Dialog from '@mui/material/Dialog';
import { DialogActions, DialogContent, DialogContentText } from '@mui/material';
import moment from 'moment';
import { debounce } from 'lodash';
import { scrollToCenterObject, scrollToObject } from 'components/helper/ui_helper';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';


interface Props {}

// Common App allows up to 15 AP Tests. UC/CSU have no card cap — only the
// Common App checkbox is limited once 15 tests are already included there.
const MAX_COMMON_APP_AP_TESTS = 15;
const COMMON_APP_LIMIT_MESSAGE = `Common App already has ${MAX_COMMON_APP_AP_TESTS} AP Tests. You can still add more for UC/CSU — the Common App checkbox will be disabled on the new tests.`;

const isCommonAppIncluded = (item: any) =>
  item?.isIncludeIntoCommonApp === true || item?.isIncludeIntoCommonApp === 'true';

const APSubjectTest = (props: Props) => {
  const [loading, setLoading] = React.useState(false);
  const [adding, setAdding] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const testing:any = useAppSelector((store:any) => store.testing);
  const dispatch:any = useAppDispatch();
  const history = useHistory();
  const location:any = useLocation();

  let studentId = getUserId();
  let token = getAccessToken();
  const query = new URLSearchParams(useLocation().search);
  const [check, setCheck] = React.useState(query.get('check'));
  const [showModal, setShowModal] = React.useState(false);
  const [showCommonAppLimitDialog, setShowCommonAppLimitDialog] = React.useState(false);
  const [testData, setTestData] = React.useState<any>(null);
  let checkIndex = query.get('index');
  const [expandAll, setExpandAll] = React.useState(false);
  const [expandActive, setExpandActive] = React.useState<number>(0);
  const [reviewedAndComplete, setReviewedAndComplete] = React.useState(false);
  const autosaveRef = React.useRef(false);
  const formikRef = React.useRef<any>(null);
  const testsRef = React.useRef<any[]>([]);
  const onReviewdAndComplete = () => {
    void toggleReviewedAndComplete(PAGE_NAME.ACT_SUBJECT_TEST, reviewedAndComplete, setReviewedAndComplete);
  }
  const formik = useFormik({
    initialValues: {
      is_have_ap_exam_report: '',
      ap_test_array: [], // Only use actual data from API
      csu_info: {
        apId: '',
      },
    },
    onSubmit: async (values: any) => {
      studentId = getUserId();
      token = getAccessToken();
      if (token && studentId) {
        try {
          for (var i = 0; i < values.ap_test_array.length; i++) {
            if (values.ap_test_array[i].examStatus === 'Planned') {
              let planToTakeExam = values.ap_test_array[i].planToTakeExam;
              let planToTakeExamMonth = planToTakeExam ? moment(planToTakeExam).format('MMMM') : 'Invalid date';
              let planToTakeExamYear = planToTakeExam ? moment(planToTakeExam).format('yyyy') : '';

              if (planToTakeExam && planToTakeExamMonth !== 'Invalid date') {
                values.ap_test_array[i].planToTakeExamMonth = planToTakeExamMonth;
                values.ap_test_array[i].planToTakeExamYear = planToTakeExamYear;
              } else {
                values.ap_test_array[i].planToTakeExamMonth = '';
                values.ap_test_array[i].planToTakeExamYear = '';
              }

              values.ap_test_array[i].dateTaken = '';
              values.ap_test_array[i].dateTakenCSUApp = '';
              values.ap_test_array[i].dateTakenMonth = '';
              values.ap_test_array[i].dateTakenYear = '';
            } else {
              let dateTaken = values.ap_test_array[i].dateTaken;
              let dateTakenCSUApp = dateTaken ? moment(dateTaken).format(dateFormat) : '';
              let dateTakenMonth = dateTaken ? moment(dateTaken).format('MMMM') : 'Invalid date';
              let dateTakenYear = dateTaken ? moment(dateTaken).format('yyyy') : '';

              if (dateTaken && dateTakenMonth !== 'Invalid date') {
                values.ap_test_array[i].dateTakenMonth = dateTakenMonth;
                values.ap_test_array[i].dateTakenYear = dateTakenYear;
                values.ap_test_array[i].dateTakenCSUApp = dateTakenCSUApp;
              } else {
                values.ap_test_array[i].dateTakenCSUApp = '';
                values.ap_test_array[i].dateTakenMonth = '';
                values.ap_test_array[i].dateTakenYear = '';
              }

              values.ap_test_array[i].planToTakeExam = '';
              values.ap_test_array[i].planToTakeExamMonth = '';
              values.ap_test_array[i].planToTakeExamYear = '';
            }
          }

          // Always save, even if some configs are missing/invalid dates.
          // Invalid configs are still surfaced via each config's own "Invalid date" validation.
          fixApSubjectTestValues(values);
          const newValues = {
            ...values,
            student_id: studentId,
            is_have_ap_exam_report: formatBoolean(values.is_have_ap_exam_report),
            ap_test_array: JSON.stringify(values.ap_test_array),
            // Remove number_of_ap_test_report dependency - let API handle the count
          };
          await dispatch(updateACTSubjectTest(newValues)).unwrap();

          if (adding) {
            setAdding(false);
          }
          autosaveRef.current = false;
        } catch (ex) {
          console.log('Error:', ex);
          autosaveRef.current = false;
        }
      } else {
        handleLogout();
      }
    },
  });
  formikRef.current = formik;
  testsRef.current = formik.values.ap_test_array ?? [];

  const persistTests = (next: any[]) => {
    testsRef.current = next;
    formikRef.current?.setFieldValue('ap_test_array', next);
  };

  const persistCard = React.useCallback((index: number, values: any) => {
    const current = testsRef.current;
    if (index < 0 || index >= current.length) return;
    const previousCommonAppCount = current.filter(isCommonAppIncluded).length;
    const nextValues = { ...values };
    const next = current.map((item, i) => (i === index ? nextValues : item));
    const nextCommonAppCount = next.filter(isCommonAppIncluded).length;
    if (nextCommonAppCount > MAX_COMMON_APP_AP_TESTS && isCommonAppIncluded(nextValues)) {
      next[index] = { ...nextValues, isIncludeIntoCommonApp: false };
    }
    const finalCommonAppCount = next.filter(isCommonAppIncluded).length;
    testsRef.current = next;
    formikRef.current?.setFieldValue('ap_test_array', next);
    if (
      previousCommonAppCount < MAX_COMMON_APP_AP_TESTS &&
      finalCommonAppCount >= MAX_COMMON_APP_AP_TESTS
    ) {
      setShowCommonAppLimitDialog(true);
    }
  }, []);

  const handleExpandAll = () => {
    if (!check) {
      setExpandAll(!expandAll);
      if (!expandAll) {
        setExpandActive(formik.values.ap_test_array.length);
      } else {
        setExpandActive(0);
      }
    } else {
      setExpandAll(!expandAll);
    }
  };

  useEffect(() => {
    // if (expandActive === formik.values.ap_test_array.length) {
    //   setExpandAll(true);
    // }

    if (expandActive === 0) {
      setExpandAll(false);
    }
  }, [expandActive, formik.values.ap_test_array.length]);

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const handleContinue = () => {
    formik.handleSubmit();
    const nextRoute = Object.keys(testing.roleTest).find(
      (key, index) =>
        index > Object.keys(testing.roleTest).indexOf('actSubjectTest') &&
        testing.roleTest[key] === true
    );
    history.push(nextRoute ? routers?.[nextRoute]?.path : routers.activities.path);
  };

  const AutoScrollAndExpand = () => {
    try {
      const hash = location.hash.slice(1); // Remove the '#' character from the hash
      console.log('hash:', hash);
      if (hash) {
        if (hash?.includes('subjectCM_') ||
            hash?.includes('isReceivedScore_') ||
            hash?.includes('dateTaken_') ||
            hash?.includes('score_')
        ) {
          setTimeout(() => {
            scrollToCenterObject(hash);
          }, 200);
        }
      }

      //#region scroll to and expand fold
      checkIndex = query.get('index');
      if (checkIndex) {
        setTimeout(() => {
          scrollToObject(`fold_${checkIndex}`, 200);
        }, 500);

        if (formik.values.ap_test_array && formik.values.ap_test_array.length>0) {
          expandFold(Number(checkIndex), formik.values.ap_test_array.length);
        }
      }     
      //#endregion
  
    }
    catch(ex){
      console.log('Error:', ex);
    }
  }


  useEffect(() => {
    AutoScrollAndExpand();
  }, [location]);

  const expandFold = (num:number, len:number) => {
    let id= `#btn_fold_${num}_${len}[aria-expanded="false"]`;
    let dv:any = document.querySelector(id);
    if (dv) dv.click();
  }

  const getDetail = async () => {
    studentId = getUserId();
    token = getAccessToken();
    if (token && studentId) {
      setLoading(true);
      const pageStatus: {
        student_completed: boolean;
      } = await pageStatusService.getPageStatusByPageName(studentId, PAGE_NAME.ACT_SUBJECT_TEST);
      if(pageStatus) {
        setReviewedAndComplete(pageStatus.student_completed);
      }
      let res = await dispatch(getACTSubjectTest(studentId));
      const dataLoaded: any = res.payload;
      if (dataLoaded) {
        // Only use actual data from API, ignore number_of_ap_test_report dependency
        const actualApTestArray = checkEnableParseJSON(dataLoaded.ap_test_array, []) ?? [];
        
        let values: any = {
          ...dataLoaded,
          ap_test_array: actualApTestArray, // Use only actual data from API
          csu_info: {
            ...formik.values.csu_info,
            ...checkEnableParseJSON(dataLoaded.csu_info),
          },
          is_have_ap_exam_report: BoolToString(dataLoaded.is_have_ap_exam_report),
        };

        fixApSubjectTestValues(values);
        setTestData(values);
        formik.resetForm({ values: values });
      }
      setLoading(false);
    } else {
      handleLogout();
    }
  };
  React.useEffect(() => {
    getDetail();
  }, []);

  React.useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);



  //#region Auto save function ==========
  React.useEffect(() => {
    formik.dirty && debounceSaving();
  }, [formik.values]);
  const debounceSaving = React.useCallback(
    debounce(() => {
      if (!loading && formikRef.current) {
        autosaveRef.current = true;
        formikRef.current.handleSubmit();
      }
    }, 1500),
    []
  );
  //#endregion ==========================
  const handleAddAP = () => {
    setAdding(true);
    let arr:any[] = [...testsRef.current, {}]
    persistTests(arr);

    setExpandAll(false);
    setExpandActive(arr.length-1);
    setTimeout(function() {
      let id=`#fold_${arr.length}_${arr.length} > div > div`;
      console.log('id:', id);
      let dv:any = document.querySelector(id);
      if (dv) dv.click();
    },1000);


  };
  const [forceRenderKey, setForceRenderKey] = React.useState(0);

  const onDragEnd = async (result: any) => {
    if (!result.destination) {
      return;
    }

    if (result.destination.index === result.source.index) {
      return;
    }
    const dataList = reorder(
      testsRef.current,
      result.source.index,
      result.destination.index
    );
    persistTests([...dataList]);
    setForceRenderKey(forceRenderKey + 1);
  };

  // ACTData now only contains actual data from API, no auto-generated empty items
  const ACTData: any[] = formik.values.ap_test_array ?? [];
  const commonAppCount = ACTData.filter(isCommonAppIncluded).length;
  const commonAppAtLimit = commonAppCount >= MAX_COMMON_APP_AP_TESTS;

  const handleExpandActive = (value: any) => {
    value
      ? setExpandActive(Math.abs(expandActive - 1))
      : setExpandActive(Math.abs(expandActive + 1));
  };
  

  const handleCheckMissing = () => {
    setCheck('1');
    setTestData(formik.values);
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    AutoScrollAndExpand();
  };


  return loading ? (
    <LoadingContent />
  ) : (
    <>
      <TopProcessBar
        stepProcess={[
          { percentOnProcess: 25, title: 'AP ID', specialId: 'apId' },
          { percentOnProcess: 100, title: 'AP Test ', specialId: 'apTestScores' },
          { percentOnProcess: 100, title: 'AP Scores', specialId: 'apScores' },
        ]}
        title="Standardized Testing"
        process={1}
        icon={<CalculateOutlinedIcon />}
        isMobile={isMobile}
      />

      <Container 
        className={`main-container gm-basic-info-page ${isMobile ? 'p-mobile-2' : ''}`}
        style={{
          paddingLeft: isMobile ? '12px' : undefined,
          paddingRight: isMobile ? '12px' : undefined,
          paddingTop: isMobile ? '120px' : undefined,
          maxWidth: '100vw',
          overflow: 'hidden'
        }}
      >
        <div className={`gm-section-card ${isMobile ? 'p-mobile-2' : 'px-4 py-4'}`}>
          <Form
            style={{ 
              maxWidth: isMobile ? '100%' : '900px',
              width: '100%'
            }}
            onSubmit={formik.handleSubmit}
            onChange={() => formik.setStatus('autoSave')}
            className="gm-form-grid"
          >
            <div className={`gm-section-title ${isMobile ? 'mb-2' : 'mb-4'}`}>
              <span style={{ fontSize: isMobile ? '18px' : '20px', fontWeight: 600 }}>
                AP Subject Tests
              </span>
            </div>
            <Grid container spacing={isMobile ? 1 : 2} className="gm-form-fields">
              <Grid xs={12} id="apId">
                <div className="my-2">Let's organize all your AP Subject test information!</div>
              </Grid>
              
              <Grid xs={isMobile ? 12 : 6}>
                <TextInput
                  countText={8}
                  name="csu_info.apId"
                  onChange={formik.handleChange}
                  values={formik.values.csu_info?.apId}
                  logo="span-csu-logo"
                  label="AP ID"
                  dataUp="ap-id"
                  disabled={reviewedAndComplete}
                />
              </Grid>

              {formik.values.ap_test_array.length > 0 && (
                <Grid xs={12}>
                  <div className="d-flex justify-content-end">
                    <ExpandMore
                      aria-expanded={expandAll}
                      aria-label="show all"
                      onClick={handleExpandAll}
                    >
                      {!expandAll ? <KeyboardDoubleArrowDownIcon /> : <KeyboardDoubleArrowUpIcon />}
                    </ExpandMore>
                  </div>
                </Grid>
              )}
              
              <Grid xs={12} id="apTestScores">
                <DragDropContext onDragEnd={onDragEnd} key={forceRenderKey}>
                  <Droppable droppableId="list">
                    {(provided) => (
                      <div className='w-100 bg-white py-2 box-collapse rounded-3' ref={provided.innerRef} {...provided.droppableProps} style={{
                        paddingRight: isMobile ? "10px" : "30px",
                        paddingLeft: "10px"
                      }}>
                        {formik.values.ap_test_array.map((item: any, index: number) => (
                          <div key={index + '-' + ACTData.length}>
                            <Draggable draggableId={index + '-' + ACTData.length} index={index} isDragDisabled={isMobile}>
                              {(provided) => (
                                <div
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...(isMobile ? {} : provided.dragHandleProps)}
                                >
                                  <div
                                    key={index + '-' + ACTData.length}
                                    id={`fold_${index+1}_${ACTData.length}`}
                                    className="position-relative"
                                  >
                                    <APSubjectConfig
                                      disabled={reviewedAndComplete}
                                      key={index}
                                      handleSave={(values) => persistCard(index, values)}
                                      item={item}
                                      index={index}
                                      indexText={index + 1 + '/' + ACTData.length}
                                      check={check}
                                      indexExpand={checkIndex + '/' + ACTData.length}
                                      expandAll={expandAll}
                                      handleExpandActive={handleExpandActive}
                                      isMobile={isMobile}
                                      commonAppLimitReached={!isCommonAppIncluded(item) && commonAppAtLimit}
                                    />
                                    <RemoveCircleOutlineIcon
                                      className="position-absolute text-field-light pointer"
                                      style={{ 
                                        right: isMobile ? '-20px' : '-24px', 
                                        top: '12px',
                                        fontSize: isMobile ? '18px' : '24px',
                                        opacity: reviewedAndComplete ? 0.5 : 1,
                                        cursor: reviewedAndComplete ? 'not-allowed' : 'pointer'
                                      }}
                                      onClick={() => {
                                        if (reviewedAndComplete) return;
                                        persistTests(testsRef.current.filter((_, i) => i !== index));
                                      }}
                                    />
                                  </div>
                                </div>
                              )}
                            </Draggable>
                          </div>
                        ))}
                        {provided.placeholder}
                      </div>
                    )}
                  </Droppable>
                </DragDropContext>
              </Grid>

              <Grid xs={12}>
                <div className="my-3 w-100 d-flex flex-column align-items-center">
                  <div className="text-field-light sized70">
                    {`You can add more AP Tests for UC/CSU. Common App accepts up to ${MAX_COMMON_APP_AP_TESTS}.`}
                  </div>
                  <Button
                    variant="primary"
                    className="p-2 px-5"
                    onClick={handleAddAP}
                    disabled={reviewedAndComplete}
                  >
                    Add AP Test
                  </Button>
                </div>
              </Grid>
            </Grid>

            {/* <div className={`${isMobile ? 'my-2' : 'my-3'} d-flex ${isMobile ? 'flex-column' : 'justify-content-between'} border-top ${isMobile ? 'pt-2' : 'pt-3'}`}>
              <div className={`${isMobile ? 'w-100 mb-3' : ''} d-flex justify-content-start`}>
                <div className="d-flex flex-column align-items-start">
                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed
                    </span>
                  </div>
                </div>
              </div>
              
              <div className={`${isMobile ? 'w-100' : 'col col-md-6'} text-center ${isMobile ? '' : 'text-md-end'}`}>
                <div className={`d-flex ${isMobile ? 'flex-column gap-2' : 'flex-row'} justify-content-center`}>
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {testing.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div> */}
                        <div className="row my-3 pt-3 mt-4 border-top">
              <div className="col-md-6">
                <div className="text-left pt-3">
                  <div className="gm-btn-checkmissing"
                    onClick={() => handleCheckMissing()}
                  >
                    <SearchIcon/><span>Check missing values</span>
                  </div>
                  <div className="d-flex align-items-center" style={{ gap: '6px' }}>
                    <input
                      type="checkbox"
                      style={{
                        width: '16px',
                        height: '16px',
                        border: '2px solid #6c757d',
                        borderRadius: '2px',
                      }}  
                      checked={reviewedAndComplete}
                      onClick={onReviewdAndComplete}
                    />
                    <span
                      style={{
                        fontSize: isMobile ? '14px' : '12px',
                        color: '#6c757d',
                        fontWeight: '500',
                      }}
                    >
                      Reviewed
                    </span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="text-start text-md-end">
                  <Button 
                    variant="primary" 
                    type="submit" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5 mx-2'} gm-btn-save`}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    {testing.status === 'loading' ? (
                      <Spinner size="sm" animation="border" variant="light" />
                    ) : (
                      'Save'
                    )}
                  </Button>
                  <Button 
                    variant="primary" 
                    className={`${isMobile ? 'w-100 py-3' : 'p-2 px-5'} gm-btn-continue`}
                    onClick={() => handleContinue()}
                    style={{
                      fontSize: isMobile ? '16px' : '14px',
                      minHeight: isMobile ? '44px' : 'auto'
                    }}
                  >
                    Continue
                  </Button>
                </div>
              </div>
            </div>
          </Form>
        </div>
        <Dialog
          open={showCommonAppLimitDialog}
          onClose={() => setShowCommonAppLimitDialog(false)}
          aria-describedby="common-app-limit-description"
        >
          <DialogContent>
            <DialogContentText id="common-app-limit-description">
              {COMMON_APP_LIMIT_MESSAGE}
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: 'flex', justifyContent: 'center' }}>
            <Button onClick={() => setShowCommonAppLimitDialog(false)}>Close</Button>
          </DialogActions>
        </Dialog>
        <ModalCheckTestFields
          show={showModal}
          onClose={handleCloseModal}
          data={testData}
          page="ap-subject-test"
        />
      </Container>
    </>
  );
};

export default APSubjectTest;
